import React, { useEffect, useState } from "react";
import "./AccordionPage.css";
import PatientDetails from "./PatientDetails";
import MedicalLog from "./Patient/MedicalLogs";
import FamilyConsultationReadOnly from "./Patient/FamilyConsultationReadOnly";
import AddNotes from "./Patient/AddNotes";
import BirthRecordForm from "./Patient/BirthRecordForm";
import Orthopedic from "./Patient/Orthopedic";
import Pediatrics from "./Patient/Pediatrics";
import GeneralSurgery from "./Patient/GeneralSurgery";
import { useParams } from "react-router-dom";
import { get, post } from "../../utility/fetch";
import toast from "react-hot-toast";

const Accordion = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className="accordion-item">
      <div
        className={`accordion-header ${isOpen ? "open" : ""}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        {title}
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>
      {isOpen && <div className="accordion-body">{children}</div>}
    </div>
  );
};

const PatientDetailsNew = () => {
  const [patient, setPatient] = useState(null);
  const { patientId } = useParams();
  const [selectedFile, setSelectedFile] = useState(null);
  const [anonymizeData, setAnonymizeData] = useState(true);
  const [uploading, setUploading] = useState(false);
  const [uploadResponse, setUploadResponse] = useState(null);

  const getPatientDetails = async () => {
    // setLoading(true);
    try {
      const data = await get(`/patients/${patientId}/data`);
      setPatient(data);
      console.log(data);
      console.log(data?.id);

      // setVisit(data?.visits?.pop());
    } catch (e) {
      console.log(e);
    }
    // setLoading(false);
  };

  useEffect(() => {
    getPatientDetails();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleUploadXray = async () => {
    if (!selectedFile) {
      toast.error("Please select a file to upload");
      return;
    }

    setUploading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("AnonymizePatientData", anonymizeData);

    try {
      const token = sessionStorage.getItem("token");
      const response = await fetch(
        "https://api.greenzonetechnologies.com.ng/medicals/api/dicom/upload",
        {
          method: "POST",
          headers: {
            Authorization: token,
          },
          body: formData,
        }
      );

      const result = await response.json();

      console.log("Upload response:", result);

      if (response.ok) {
        toast.success("X-ray uploaded successfully");
        setUploadResponse(result);
        setSelectedFile(null);
        // Reset file input
        document.getElementById("xray-file-input").value = "";
      } else {
        toast.error(result.message || "Failed to upload X-ray");
      }
    } catch (error) {
      console.error("Upload error:", error);
      toast.error("Error uploading X-ray");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="accordion-container">
      <h4>{patient?.firstName + " " + patient?.lastName}</h4>

      <Accordion title="Patient Information">
        <PatientDetails
          patient={patient}
          visibleTabs={[
            "personal",
            "appointments",
            "medicalRecordFiles",
            "treatment",
            "immunization",
            "contactDetails",
            "emergencyContact",
            "healthMonitoring",
            // "medicalRecord",
            "visits",
            "specialty",
          ]}
        />
      </Accordion>

      <Accordion title="Dicom Upload">
        <div style={{ padding: "20px" }}>
          <h4>Upload X-ray Image</h4>

          <div style={{ marginTop: "15px", marginBottom: "15px" }}>
            <label
              htmlFor="xray-file-input"
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "500",
              }}
            >
              Select DICOM File:
            </label>
            <input
              id="xray-file-input"
              type="file"
              onChange={handleFileChange}
              accept=".dcm,.dicom"
              style={{
                padding: "8px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                width: "100%",
                maxWidth: "400px",
              }}
            />
            {selectedFile && (
              <p style={{ marginTop: "8px", color: "#666", fontSize: "14px" }}>
                Selected: {selectedFile.name}
              </p>
            )}
          </div>

          <div style={{ marginBottom: "15px" }}>
            <label
              style={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <input
                type="checkbox"
                checked={anonymizeData}
                onChange={(e) => setAnonymizeData(e.target.checked)}
              />
              <span>Anonymize Patient Data</span>
            </label>
          </div>

          <button
            onClick={handleUploadXray}
            disabled={uploading || !selectedFile}
            style={{
              padding: "10px 20px",
              backgroundColor: uploading || !selectedFile ? "#ccc" : "#3c7e2d",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: uploading || !selectedFile ? "not-allowed" : "pointer",
              fontWeight: "500",
            }}
          >
            {uploading ? "Uploading..." : "Upload X-ray"}
          </button>

          {uploadResponse && (
            <div style={{ marginTop: "30px" }}>
              <div
                style={{
                  backgroundColor: "#f9f9f9",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "20px",
                  marginBottom: "20px",
                }}
              >
                <h4 style={{ marginBottom: "15px", color: "#3c7e2d" }}>
                  Patient Metadata
                </h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "12px",
                  }}
                >
                  <div>
                    <strong>Patient Name:</strong>{" "}
                    {uploadResponse.metadata.patientName || "N/A"}
                  </div>
                  <div>
                    <strong>Patient ID:</strong>{" "}
                    {uploadResponse.metadata.patientId || "N/A"}
                  </div>
                  <div>
                    <strong>Sex:</strong>{" "}
                    {uploadResponse.metadata.patientSex || "N/A"}
                  </div>
                  <div>
                    <strong>Age:</strong>{" "}
                    {uploadResponse.metadata.patientAge || "N/A"}
                  </div>
                  <div>
                    <strong>Study Date:</strong>{" "}
                    {uploadResponse.metadata.studyDate || "N/A"}
                  </div>
                  <div>
                    <strong>Modality:</strong>{" "}
                    {uploadResponse.metadata.modality || "N/A"}
                  </div>
                  <div>
                    <strong>Body Part:</strong>{" "}
                    {uploadResponse.metadata.bodyPartExamined || "N/A"}
                  </div>
                  <div>
                    <strong>Manufacturer:</strong>{" "}
                    {uploadResponse.metadata.manufacturer || "N/A"}
                  </div>
                  <div>
                    <strong>Institution:</strong>{" "}
                    {uploadResponse.metadata.institutionName || "N/A"}
                  </div>
                  <div style={{ gridColumn: "1 / -1" }}>
                    <strong>Study Description:</strong>{" "}
                    {uploadResponse.metadata.studyDescription || "N/A"}
                  </div>
                </div>
              </div>

              <div
                style={{
                  backgroundColor: "#f0f8ff",
                  border: "1px solid #b3d9ff",
                  borderRadius: "8px",
                  padding: "20px",
                }}
              >
                <h4 style={{ marginBottom: "15px", color: "#0066cc" }}>
                  Image Analysis
                </h4>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                    gap: "12px",
                  }}
                >
                  <div>
                    <strong>Is DICOM:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.isDicom
                          ? "green"
                          : "red",
                      }}
                    >
                      {uploadResponse.analysis.isDicom ? "Yes" : "No"}
                    </span>
                  </div>
                  <div>
                    <strong>Is X-ray:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.isXray ? "green" : "red",
                      }}
                    >
                      {uploadResponse.analysis.isXray ? "Yes" : "No"}
                    </span>
                  </div>
                  <div>
                    <strong>Image Dimensions:</strong>{" "}
                    {uploadResponse.analysis.rows} x{" "}
                    {uploadResponse.analysis.columns} pixels
                  </div>
                  <div>
                    <strong>Acceptable Resolution:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.hasAcceptableResolution
                          ? "green"
                          : "orange",
                      }}
                    >
                      {uploadResponse.analysis.hasAcceptableResolution
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>
                  <div>
                    <strong>kVp:</strong> {uploadResponse.analysis.kvp || "N/A"}
                  </div>
                  <div>
                    <strong>Exposure:</strong>{" "}
                    {uploadResponse.analysis.exposure || "N/A"}
                  </div>
                  <div>
                    <strong>Exposure (µAs):</strong>{" "}
                    {uploadResponse.analysis.exposureInuAs || "N/A"}
                  </div>
                  <div>
                    <strong>Under Exposed:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.isUnderExposed
                          ? "red"
                          : "green",
                      }}
                    >
                      {uploadResponse.analysis.isUnderExposed ? "Yes" : "No"}
                    </span>
                  </div>
                  <div>
                    <strong>Over Exposed:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.isOverExposed
                          ? "red"
                          : "green",
                      }}
                    >
                      {uploadResponse.analysis.isOverExposed ? "Yes" : "No"}
                    </span>
                  </div>
                  <div>
                    <strong>View Position:</strong>{" "}
                    {uploadResponse.analysis.viewPosition || "N/A"}
                  </div>
                  <div>
                    <strong>Detected Body Part:</strong>{" "}
                    {uploadResponse.analysis.detectedBodyPart || "N/A"}
                  </div>
                  <div>
                    <strong>AI Analysis Performed:</strong>{" "}
                    <span
                      style={{
                        color: uploadResponse.analysis.aiAnalysisPerformed
                          ? "green"
                          : "gray",
                      }}
                    >
                      {uploadResponse.analysis.aiAnalysisPerformed
                        ? "Yes"
                        : "No"}
                    </span>
                  </div>
                  {uploadResponse.analysis.aiAnalysisPerformed && (
                    <>
                      <div>
                        <strong>AI Confidence Score:</strong>{" "}
                        {(
                          uploadResponse.analysis.aiConfidenceScore * 100
                        ).toFixed(1)}
                        %
                      </div>
                      <div style={{ gridColumn: "1 / -1" }}>
                        <strong>AI Summary:</strong>{" "}
                        {uploadResponse.analysis.aiSummary || "N/A"}
                      </div>
                    </>
                  )}
                  {uploadResponse.metadata.studyInstanceUid && (
                    <div style={{ gridColumn: "1 / -1", fontSize: "12px" }}>
                      <strong>Study Instance UID:</strong>{" "}
                      {uploadResponse.metadata.studyInstanceUid}
                    </div>
                  )}
                  {uploadResponse.metadata.seriesInstanceUid && (
                    <div style={{ gridColumn: "1 / -1", fontSize: "12px" }}>
                      <strong>Series Instance UID:</strong>{" "}
                      {uploadResponse.metadata.seriesInstanceUid}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </Accordion>
    </div>
  );
};

export default PatientDetailsNew;
